goog.provide('el8.util.ss');


el8.util.ss = {

    isSuccess: function(state) {
        return state === 'pending_complete' || state === 'complete';
    },

    isError: function(state) {
        return state === 'error' || state === 'failure';
    },

    isPending: function(state) {
        return state === 'new' || state === 'sending' || state === 'sent';
    }

};


